import { createRoute, useParams } from "@tanstack/solid-router";
// FLAGS: the lesson-plan view (flipped classroom) is gated by feature (active org).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { appRoute } from "./route";
import { SessionPlanView } from "@/features/academy/components/session-plan-view";

function SessionPlanPage() {
  const params = useParams({ from: "/_app/schedule/$sessionId" });
  return <SessionPlanView sessionId={params().sessionId} />;
}

export const sessionPlanRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/schedule/$sessionId",
  component: withFeatureGate("academy.flipped_sessions", SessionPlanPage),
});
